//import i18n from '@/_helpers/lang';
import { extend } from "vee-validate";
import { required, is_not, email, digits, regex, numeric, min_value, max_value } from "vee-validate/dist/rules";

extend('required', required);
extend('is_not', is_not);
extend('numeric', numeric);
extend('min_value', min_value);
extend('max_value', max_value);
/*extend('min_value', {
    min_value,
    message: i18n.t('porGradoDiscError')
});
extend('max_value', {
    max_value,
    message: this.$t('porGradoDiscError')
});*/
extend('email', email);
extend('digits', digits);
extend('regex', regex);


export const rules = {
    email: {
        email,
    },
    telephone: {
        digits: 9
    },
    requiredField: {
        required: true
    },
    perDiscapacidad: {
        max_value: 100,
        min_value: 0
    },
    iban: {
        regex: /^([0-9]{2})/,
    },
    swift: {
        regex: /^([0-9a-zA-Z]{11})|^([0-9a-zA-Z]{8})/,
    }
};